import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { jsPDF } from "jspdf";
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { IMG_CAMINHO } from 'src/app/app.api';
import { AtributoAdicional } from 'src/app/shared/model/atributo-adicional.model';
import { ClienteProjeto } from 'src/app/shared/model/cliente-projeto.model';
import { Cliente } from 'src/app/shared/model/cliente.model';
import { ComodoAtributoVariacao } from 'src/app/shared/model/comodo-atributo-variacao.model';
import { ComodoAtributo } from 'src/app/shared/model/comodo-atributo.model';
import { Comodo } from 'src/app/shared/model/comodo.model';
import { ConfiguracoesFinanciamento } from 'src/app/shared/model/configuracoes-financiamento.model';
import { Contador } from 'src/app/shared/model/contador.model';
import { Corretor } from 'src/app/shared/model/corretor.model';
import { Financiamento } from 'src/app/shared/model/financiamento.model';
import { DataService } from 'src/app/shared/service/data.service';

@Component({
  selector: 'dom436-success',
  templateUrl: './success.component.html'
})
export class SuccessComponent implements OnInit {
  modalRef: BsModalRef;
  corretor: Corretor = {id: undefined, nome: ''};
  cliente: Cliente = {id: undefined, apartamento: {id: undefined, nome: '', imagem: '', planta: {id: undefined, nome: '', imagem: '', descricao: '', metragem: {id: undefined, valor: undefined}}, preco: undefined, andar: undefined, orientacao: '', numQuartos: undefined, numBanheiros: undefined, numVagas: undefined, status: undefined, torre: undefined}, corretor: {id: undefined, nome: ''}, segmento: undefined, valorBase: undefined, valorAdicional: undefined, valorTotal:undefined, codigoUrl: '', nome: '', cpf: '', email: '', telefone: '', celular: '', logradouro: '', numero: '', complemento: '', bairro: '', regiaoMunicipio: undefined, cep: '', status: undefined, createdAt: undefined, updatedAt: undefined}; 
  clienteProjetoItens: ClienteProjeto[] = [];
  comodos: Comodo[] = [];
  comodosAtributos: ComodoAtributo[] = [];
  comodosAtributosVariacoes: ComodoAtributoVariacao[] = [];
  atributosAdicionais: AtributoAdicional[] = [];
  cadastroSalvo: boolean = false;
  caminhoImg: string = null;
  comodoAnterior: number = 0;
  simuladorEntrada: number = 0;
  simuladorPrazo: number = 10;
  simuladorPrazoLimite: number = 0;
  simuladorTaxaJuros: number = 0;
  simuladorValorParcelas: number = 0;
  simuladorValorTotalParcelas: number = 0;
  simuladorValorFinalApartamento: number = 0;
  financiamento: Financiamento = {valorBase: undefined, valorEntrada: undefined, valorJuros: undefined, valorParcela: undefined, taxaJuros: undefined, numeroParcelas: undefined, valorTotal: undefined};
  comodo: Comodo = {id: undefined, planta: undefined, nome: '', descricao: '', imagem: '', status: undefined};
  comodoAtributoVariacao: ComodoAtributoVariacao = {id: undefined, comodoAtributo: undefined, nome: '', descricao: '', imagem: '', imagemThumbnail: '', preco: undefined, status: undefined }
  carouselOptions: OwlOptions = {
    items: 1,
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    nav: true,
    navText:["<div class='nav-btn prev-slide'><img alt='Seta' src='assets/images/arrow-left-black.svg' /></div>","<div class='nav-btn next-slide'><img alt='Seta' src='assets/images/arrow-right-black.svg' /></div>"],
    autoplay: false,
    responsive: {
      0: {
        items: 1 
      }
    },
  }

  constructor(private modalService: BsModalService,
    private dataService: DataService,
    private route: ActivatedRoute,
    private router: Router) {
      let codigoUrl = this.route.snapshot.params['codigoUrl'];
      if(codigoUrl === 'novo') {
        this.cliente = JSON.parse(sessionStorage.getItem('cliente'));
        this.clienteProjetoItens = JSON.parse(sessionStorage.getItem('clienteProjeto'));
        this.corretor = JSON.parse(sessionStorage.getItem('selectedCorretor'));
        let tipoAcesso = sessionStorage.getItem('tipoAcesso');
        if(!tipoAcesso || tipoAcesso !== 'teste') {
          this.incrementarContador(this.cliente.apartamento.id, 3);
        }
        if(!this.cliente) {
          this.router.navigate(['/selecionar-apartamento']);
        }
      } else {
        this.cadastroSalvo = true;
        this.dataService.getClienteByCodigoUrl(codigoUrl)
          .subscribe(cliente => {
            if(cliente) {
              this.cliente = cliente;
              this.dataService.ListProjetoByCliente(cliente.id)
                .subscribe(clienteProjeto => {
                  this.clienteProjetoItens = clienteProjeto;
                });
            } else {
              this.router.navigate(['/selecionar-apartamento']);
            }
          },
          (err) => {
            this.router.navigate(['/selecionar-apartamento']);
          });
      }
  }

  ngOnInit(): void {
    this.caminhoImg = IMG_CAMINHO;
    this.dataService.listComodos()
      .subscribe(comodos => {
        this.comodos = comodos.filter(comodo => { return comodo.planta.id === this.cliente.apartamento.planta.id });
      });
    this.dataService.listComodosAtributos()
      .subscribe(comodosAtributos => {
        this.comodosAtributos = comodosAtributos.filter(comodoAtributo => { return comodoAtributo.comodo.planta.id === this.cliente.apartamento.planta.id });
      });
    this.dataService.listComodosAtributosVariacoes()
      .subscribe(comodosAtributosVariacoes => { 
        this.comodosAtributosVariacoes = comodosAtributosVariacoes.filter(comodoAtributoVariacao => { return comodoAtributoVariacao.comodoAtributo.comodo.planta.id === this.cliente.apartamento.planta.id; });
      });
    this.dataService.listAtributosAdicionais()
      .subscribe(atributosAdicionais => {
        this.atributosAdicionais = atributosAdicionais;
      });
    this.dataService.getConfiguracoesFinanciamento()
      .subscribe((configuracoesFinanciamento: ConfiguracoesFinanciamento) => {
        this.simuladorPrazoLimite = configuracoesFinanciamento.limiteAnos;
        this.simuladorTaxaJuros = configuracoesFinanciamento.taxaJuros;
      })
  }

  getComodoAtributosByComodo(comodoId: number) {
    let comodoAtributosByComodo = this.comodosAtributos.filter(comodoAtributo => { return comodoAtributo.comodo.id === comodoId });
    return comodoAtributosByComodo;
  }

  getComodoAtributoVariacaoBySession(comodoAtributoId: number) {
    let clienteProjetoAtributo = this.clienteProjetoItens.filter(clienteProjeto => { return clienteProjeto.comodoAtributo === comodoAtributoId })[0];
    if(clienteProjetoAtributo) {
      let comodoAtributoVariacaoBySession = this.comodosAtributosVariacoes.filter(comodoAtributoVariacao => { return comodoAtributoVariacao.id === clienteProjetoAtributo.comodoAtributoVariacao });
      if(comodoAtributoVariacaoBySession) {
        return comodoAtributoVariacaoBySession;
      } else {
        let comodoAtributoVariacaoNaoSelecionado: ComodoAtributoVariacao[] = [{
          id: undefined,
          comodoAtributo: this.comodosAtributos.filter(comodoAtributo => { return comodoAtributo.id === comodoAtributoId })[0],
          nome: 'Nenhum',
          descricao: 'Não Selecionado',
          imagem: '',
          imagemThumbnail: '',
          preco: 0,
          status: true
        }];
        return comodoAtributoVariacaoNaoSelecionado;
      }
    } else {
      let comodoAtributoVariacaoNaoSelecionado: ComodoAtributoVariacao[] = [{
        id: undefined,
        comodoAtributo: this.comodosAtributos.filter(comodoAtributo => { return comodoAtributo.id === comodoAtributoId })[0],
        nome: 'Nenhum',
        descricao: '(Não Selecionado)',
        imagem: '',
        imagemThumbnail: '',
        preco: 0,
        status: true
      }];
      return comodoAtributoVariacaoNaoSelecionado;
    }
  }

  getAtributosAdicionais() {
    let atributosAdicionaisSession: AtributoAdicional[] = [];
    this.clienteProjetoItens.forEach(clienteProjeto => {
      if(clienteProjeto.atributoAdicional) {
        let atributoAdicionalFiltered = this.atributosAdicionais.filter(atributoAdicional => { return atributoAdicional.id === clienteProjeto.atributoAdicional })[0];
        if(atributoAdicionalFiltered) {
          atributosAdicionaisSession.push(atributoAdicionalFiltered);
        }
      }
    });
    return atributosAdicionaisSession;
  }

  getColor(value) {
    let projetoItemFiltered = this.clienteProjetoItens.filter(clienteProjeto => { return clienteProjeto.comodoAtributoVariacao === value })[0];
    return projetoItemFiltered.cor;
  }

  shareModal(templateShare: TemplateRef<any>, configuratorSuccessModal: TemplateRef<any>) {
    if(this.cadastroSalvo) {
      this.openModal(templateShare);
    } else {
      this.openModal(configuratorSuccessModal);
    }
  }

  getComodosSemCozinha() {
    let comodos = this.comodos.filter(comodo => { return comodo.nome !== 'Cozinha' });
    return comodos;
  }

  getComodosBanheiroSala() {
    let comodos = this.comodos.filter(comodo => { return comodo.nome === 'Sala' || comodo.nome === 'Banho' });
    return comodos;
  }

  checkModal(configuratorSuccessModal: TemplateRef<any>) {
    if(this.cadastroSalvo) {
      window.print();
    } else {
      this.openModal(configuratorSuccessModal);
    }
  }

  saveModal(configuratorSuccessModal: TemplateRef<any>) {
    if(this.cadastroSalvo) {
      this.downloadPDF();
    } else {
      this.openModal(configuratorSuccessModal);
    }
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      { class: 'modal-success' }
    );
  }

  confirmConfiguration() {
    this.dataService.saveConclusao(this.cliente)
      .subscribe();
  }

  salvarCliente(clienteForm: Cliente) {
    this.cliente.id = null;
    if(this.corretor) {
      this.cliente.corretor = this.corretor;
    }
    this.cliente.nome = clienteForm.nome;
    this.cliente.email = clienteForm.email;
    this.cliente.celular = clienteForm.celular;
    this.cliente.codigoUrl = this.randomString(12, '0123456789abcdefghijklmnopqrstuvwxyz');
    this.cliente.status = 1;
    this.dataService.saveCliente(this.cliente)
      .subscribe(clienteCadastrado => {
        this.dataService.saveClienteProjeto(clienteCadastrado.id, this.clienteProjetoItens)
          .subscribe(clienteProjeto => {
            this.router.navigate(['decorar-apartamento/sucesso/', this.cliente.codigoUrl]);
            this.cadastroSalvo = true;
          });
      });
  }

  randomString(length, chars) {
    var result = '';
    for (var i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
    return result;
  }

  getCurrentUrl() {
    return window.location.href;
  }

  copyLink(inputElement) {
    inputElement.select();
    document.execCommand('copy');
    inputElement.setSelectionRange(0, 99999999999);
  }

  getComodoVariacoes(comodoId) {
    if(this.comodosAtributosVariacoes.length) {
      let projetoItensByComodo = this.clienteProjetoItens.filter(clienteProjeto => { return clienteProjeto.comodo === comodoId });
      let comodosAtributosVariacoes: ComodoAtributoVariacao[] = [];
      projetoItensByComodo.forEach(projetoItem => {
        let comodoAtributoVariacao = this.comodosAtributosVariacoes.filter(comodoAtributoVariacao => { return comodoAtributoVariacao.id === projetoItem.comodoAtributoVariacao })[0];
        if(comodoAtributoVariacao && comodoAtributoVariacao !== undefined && comodoAtributoVariacao.imagem) {
          comodosAtributosVariacoes.push(comodoAtributoVariacao);
        }
      });
      return comodosAtributosVariacoes;
    }
  }

  getSvgColor(comodoAtributoVariacaoId) {
    let projetoItemByComodoAtributoVariacao = this.clienteProjetoItens.filter(clienteProjeto => { return clienteProjeto.comodoAtributoVariacao === comodoAtributoVariacaoId })[0];
    return projetoItemByComodoAtributoVariacao.cor;
  }

  setSimuladorEntrada(event) {
    let value = parseFloat(event.target.value.replace('R$ ', '').replace('.', '').replace(',', '.'));
    this.simuladorEntrada = value;
    if(value > this.cliente.valorTotal) {
      this.simuladorEntrada = 0;
    }
  }

  setSimuladorPrazo(event) {
    let value = event.target.value;
    this.simuladorPrazo = value;
    if(value > this.simuladorPrazoLimite) {
      this.simuladorPrazo = this.simuladorPrazoLimite;
    }
  }

  getSimuladorValoresTotais() {
    let valorApartamento = this.cliente.valorTotal;
    let valorFinanciar = valorApartamento - this.simuladorEntrada;
    this.financiamento.valorBase = valorFinanciar;
    this.financiamento.valorEntrada = this.simuladorEntrada;
    this.financiamento.numeroParcelas = this.simuladorPrazo * 12;
    this.financiamento.taxaJuros =this.simuladorTaxaJuros;
    this.dataService.calcularJuros(this.financiamento)
      .subscribe((financiamentoRetorno: Financiamento) => {
        this.financiamento = financiamentoRetorno;
        this.simuladorValorParcelas = financiamentoRetorno.valorParcela;
        this.simuladorValorTotalParcelas = financiamentoRetorno.valorTotal - financiamentoRetorno.valorEntrada;
        this.simuladorValorFinalApartamento = financiamentoRetorno.valorTotal;
      });
  }

  somaPrecoUnitario(comodoAtributoVariacao) {
    return comodoAtributoVariacao.comodoAtributo.valorUnitario ? comodoAtributoVariacao.preco * comodoAtributoVariacao.comodoAtributo.valorUnitario : comodoAtributoVariacao.preco;
  }

  incrementarContador(apartamentoId, tipo) {
    let contador: Contador = {apartamentoId, tipo};
    contador.apartamentoId = apartamentoId;
    contador.tipo = tipo;
    this.dataService.incrementarContador(contador)
      .subscribe();
  }

  @ViewChild('printContent', {static: false}) printContent: ElementRef;
  public downloadPDF() {
    const doc = new jsPDF('p','pt', 'a4');
    const content = this.printContent.nativeElement;
    doc.html(content, {
        x: 75,
        y: 15,
        html2canvas: {
          scale: 0.75,
            windowWidth: 1024,
            windowHeight: 10
        },
        callback: (doc) => {
          doc.save(this.cliente.codigoUrl+'.pdf');
        }
    });
  }
}
